import React from 'react';

const AsyncComponent = loadComponent => (
	class AsyncComponent extends React.Component {

		constructor(props,conext){
			super(props,conext);
			this.state = {
				// short for "module" but that's a keyword in js, so "mod"
				Component: null,
			};
		}
		componentWillMount() {
			if (this.hasLoadedComponent()) {
				return;
			}

			loadComponent()
				.then(module => module.default)
				.then((Component) => {
					this.setState({Component});
				})
				.catch((err) => {
					console.error('Cannot load component in <AsyncComponent />');
					throw err;
				});
		}

		hasLoadedComponent() {
			return this.state.Component !== null;
		}

		render() {
			const {Component} = this.state;
			return (Component) ? <Component {...this.props} /> : null;
		}
	}
);

export default AsyncComponent;



// WEBPACK FOOTER //
// ./src/components/public/asyncComponent/index.js